// components/BlogPost.js
import BlogCategoriesBlock from './BlogCategoriesBlock'
import BlogExcerptBlock from './BlogExcerptBlock'
import BlogTitleBlock from './BlogTitleBlock'
import BlogFeaturedImage from './BlogFeaturedImage'
import BlogDateBlock from './BlogDateBlock'
// import BlogTagsBlock from './BlogTagsBlock'

export const BlogPost = ({
    post,
    categories,
    showExcerpt = true,
    image = 'normal',
    viewStyle = 'vertical',
    isSidePosts = false,
}) => {
    const imageHeight =
        image === 'small' ? 'h-20' : image === 'medium' ? 'h-40' : 'h-60'

    return (
        <div
            className={`bg-transparent rounded-lg overflow-hidden ${
                viewStyle === 'horizontal' ? 'flex items-start' : ''
            }`}>
            {viewStyle === 'horizontal' && (
                <div className={'relative w-20 pr-2'}>
                    <BlogFeaturedImage post={post} size={image} />
                </div>
            )}

            {viewStyle === 'vertical' && (
                <div
                    className={`relative w-full bg-gray-200 mb-4 ${imageHeight}`}>
                    <BlogFeaturedImage post={post} size="medium" />
                </div>
            )}
            <div
                className={`p-1 space-y-2 ${
                    viewStyle === 'horizontal' ? 'w-3/4' : ''
                }`}>
                <div
                    className={`text-xs ${
                        !isSidePosts
                            ? 'font-normal flex flex-wrap items-center'
                            : ''
                    } text-orange-600 uppercase tracking-wide`}>
                    <BlogCategoriesBlock post={post} categories={categories} />
                    <div className="px-1"></div>
                    {!isSidePosts && (
                        <BlogDateBlock post={post} isSidePosts={isSidePosts} />
                    )}
                </div>
                <BlogTitleBlock
                    post={post}
                    size={isSidePosts ? 'text-base' : 'text-2xl'}
                    isSidePosts={isSidePosts}
                />

                {showExcerpt && <BlogExcerptBlock post={post} />}
                {isSidePosts && (
                    <BlogDateBlock post={post} isSidePosts={isSidePosts} />
                )}
                {/* <BlogTagsBlock post={post} /> */}
            </div>
        </div>
    )
}
